var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOpenBin = function SvgOpenBin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.97 28.7"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".open-bin_svg__cls-1{fill:none;stroke:#58595b;stroke-linecap:round;stroke-linejoin:round}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "open-bin_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "open-bin_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "open-bin_svg__Shape_1471",
    d: "m.5.88 20 6.48",
    className: "open-bin_svg__cls-1",
    "data-name": "Shape 1471"
  }), /*#__PURE__*/React.createElement("path", {
    id: "open-bin_svg__Shape_1472",
    d: "M13.55 2 9.27.57a1.51 1.51 0 0 0-1.89 1L6.92 3l7.13 2.32.47-1.43A1.51 1.51 0 0 0 13.55 2",
    className: "open-bin_svg__cls-1",
    "data-name": "Shape 1472"
  }), /*#__PURE__*/React.createElement("path", {
    id: "open-bin_svg__Shape_1473",
    d: "M6.7 23v-7.5",
    className: "open-bin_svg__cls-1",
    "data-name": "Shape 1473"
  }), /*#__PURE__*/React.createElement("path", {
    id: "open-bin_svg__Shape_1474",
    d: "M11.2 23v-7.5",
    className: "open-bin_svg__cls-1",
    "data-name": "Shape 1474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "open-bin_svg__Shape_1475",
    d: "M15.82 26.82a1.51 1.51 0 0 1-1.5 1.38H3.58a1.49 1.49 0 0 1-1.49-1.38L.7 10.2h16.5Z",
    className: "open-bin_svg__cls-1",
    "data-name": "Shape 1475"
  })))));
};
export { SvgOpenBin as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMC45NyAyOC43Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6bm9uZTtzdHJva2U6IzU4NTk1YjtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7fTwvc3R5bGU+PC9kZWZzPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+PHBhdGggaWQ9IlNoYXBlXzE0NzEiIGRhdGEtbmFtZT0iU2hhcGUgMTQ3MSIgY2xhc3M9ImNscy0xIiBkPSJNLjUuODhsMjAsNi40OCIvPjxwYXRoIGlkPSJTaGFwZV8xNDcyIiBkYXRhLW5hbWU9IlNoYXBlIDE0NzIiIGNsYXNzPSJjbHMtMSIgZD0iTTEzLjU1LDIsOS4yNy41N2ExLjUxLDEuNTEsMCwwLDAtMS44OSwxTDYuOTIsM2w3LjEzLDIuMzIuNDctMS40M0ExLjUxLDEuNTEsMCwwLDAsMTMuNTUsMloiLz48cGF0aCBpZD0iU2hhcGVfMTQ3MyIgZGF0YS1uYW1lPSJTaGFwZSAxNDczIiBjbGFzcz0iY2xzLTEiIGQ9Ik02LjcsMjN2LTcuNSIvPjxwYXRoIGlkPSJTaGFwZV8xNDc0IiBkYXRhLW5hbWU9IlNoYXBlIDE0NzQiIGNsYXNzPSJjbHMtMSIgZD0iTTExLjIsMjN2LTcuNSIvPjxwYXRoIGlkPSJTaGFwZV8xNDc1IiBkYXRhLW5hbWU9IlNoYXBlIDE0NzUiIGNsYXNzPSJjbHMtMSIgZD0iTTE1LjgyLDI2LjgyYTEuNTEsMS41MSwwLDAsMS0xLjUsMS4zOEgzLjU4YTEuNDksMS40OSwwLDAsMS0xLjQ5LTEuMzhMLjcsMTAuMkgxNy4yWiIvPjwvZz48L2c+PC9zdmc+";